<!--
 * @Author: 张天昊
 * @Date: 2024-05-17 10:17:09
 * @LastEditTime: 2024-06-24 17:37:44
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/pages/itineraryUniversal/detail.vue
-->
<script>
import { defineComponent, onUnmounted, ref, computed, getCurrentInstance } from 'vue';
import BasicInfoHeader from './components/BasicInfoHeader.vue';
import DetailTabs from './components/DetailTabs.vue';
import OperationBar from './components/OperationBar.vue';
import store from '@/store';
import router from '@/router/routers';
// import { ItineraryUniversalChannel } from './channel';

export default defineComponent({
  components: {
    BasicInfoHeader,
    DetailTabs,
    OperationBar
  },
  setup() {
    const route = router.currentRoute;
    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo
    );
    init();
    function init() {
      route.query.scene &&
        store.commit('itineraryUniversal/setScene', route.query.scene);
      store.dispatch('itineraryUniversal/getDetailInfo', route.params.id);
    }

    // 行程单详情卸载广播
    // onUnmounted(() => {
    //   ItineraryUniversalChannel.postMessage({
    //     type: 'destroyed'
    //   });
    // });
    // window.addEventListener('unload', () => {
    //   ItineraryUniversalChannel.postMessage({
    //     type: 'destroyed'
    //   });
    // });
    return {
      detailInfo
    };
  }
});
</script>

<template>
  <div class="bg-board-a text-black-a">
    <template v-if="detailInfo.loading">
      <div class="w-screen h-screen flex flex-col items-center justify-center">
        <van-loading :size="48" color="#36B374"  />
      </div>
    </template>
    <template v-else-if="!detailInfo.loading && detailInfo.value">
      <BasicInfoHeader />
      <DetailTabs />
      <OperationBar />
    </template>
  </div>
</template>

<style>
@import url(./styles/customize.css);
</style>
